import { render, staticRenderFns } from "./NormalVectorOverlay.vue?vue&type=template&id=21d914cc&"
import script from "./NormalVectorOverlay.vue?vue&type=script&lang=js&"
export * from "./NormalVectorOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports